import * as ActionTypes from "../ActionTypes";
const initialState = {
  keyPerformanceByAgentExport: [
    {
      agentMail: "",
      agentName: "",
      appId: "",
      beneName: "",
      planName: "",
      mediCareId: "",
      status: "",
    },
  ],
  keyPerformanceByCampaignExport: [
    {
      campaignId: "",
      campaignName: "",
      beneficiaryName: "",
      beneficiaryAddress: "",
    },
  ],
  hydrated: false,
};
const KeyPerformanceReducer = (state, action) => {
  if (!state || !state.hydrated) {
    state = {
      ...initialState,
      ...state,
      hydrated: true,
    };
  }
  switch (action.type) {
    case ActionTypes.EXPORT_PERFORMANCE_BY_AGENT:
      //   let exportdetails=action.payload.data?.length?
      //   action.payload.data.map((z)=>
      //     z.agentExportDetails
      //   )
      // :action.payload.data
      // console.log("array--",exportdetails)
      // //below if block is used to get tha excel data
      //   if(action.payload.data?.length){
      //   exportdetails.map((z,index)=>{
      //   for(let i=0;i<z.length;i++){
      //     Object.assign(z[i],{agentMail:action.payload.data[index].agentMail,agentName:action.payload.data[index].agentName})
      //   }
      //     }
      //   )}
      //   let exportData=[]
      //   for(let i=0;i<exportdetails.length;i++){
      //   exportData=exportData.concat(exportdetails[i])
      //   }
      //console.log("final--",exportData)
      return {
        ...state,
        keyPerformanceByAgentExport: action.payload.data,
      };
    case ActionTypes.EXPORT_PERFORMANCE_BY_CAMPAIGN:
      return {
        ...state,
        keyPerformanceByCampaignExport: action.payload.data,
      };
    default:
      return state;
  }
};
export default KeyPerformanceReducer;
